"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleLogoutAction } from "@/resources/actions/auth.actions";
import { queryKeys } from "@/lib/query-keys";

/**
 * Logout mutation hook
 * Handles user logout with cache clearing
 */
export function useLogoutMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await handleLogoutAction();
    },
    onSuccess: () => {
      // Clear all queries on logout
      queryClient.clear();

      // Or selectively invalidate auth queries
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.all });
    },
    onError: (error: Error) => {
      // console.log("error", error);
      console.error("Logout failed:", error.message);
    },
  });
}
